document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.header');
	const headerTabsMenuItems = document.querySelectorAll('button.header-tabs-menu__item[data-content]');
	const headerTabsContentItems = document.querySelectorAll('.header-tabs-content__item');
	const headerTabsContentContainer = document.querySelector('.header-tabs-content');
	const mobile = window.innerWidth < 768;
	let headerTabsContentContainerHeight = 0;

	if (!mobile) {
		header.addEventListener(
			'mouseenter',
			() => {
				headerTabsContentItems.forEach((contentItem) => {
					const itemHeight = contentItem.scrollHeight;

					if (itemHeight > headerTabsContentContainerHeight) {
						headerTabsContentContainerHeight = itemHeight;
					}
				});

				if (headerTabsContentContainer) {
					headerTabsContentContainer.style.height = `calc(2 * var(--space-tiny) + ${headerTabsContentContainerHeight}px)`;
				}

				headerTabsContentItems.forEach((contentItem) => {
					contentItem.style.position = 'absolute';
				});
			},
			{ once: true }
		);
	}

	headerTabsMenuItems.forEach((menuItem) => {
		const contentItem = document.querySelector(`#${menuItem.dataset.content}`);

		if (mobile) {
			if (contentItem) {
				menuItem.insertAdjacentElement('afterend', contentItem);
			}
		}

		menuItem.addEventListener('click', () => {
			const currentlyActiveMenuItem = document.querySelector('.header-tabs-menu__item--active');
			const currentlyActiveContentItem = document.querySelector('.header-tabs-content__item--visible');

			if (currentlyActiveMenuItem) currentlyActiveMenuItem.classList.remove('header-tabs-menu__item--active');
			if (currentlyActiveContentItem) currentlyActiveContentItem.classList.remove('header-tabs-content__item--visible');

			menuItem.classList.add('header-tabs-menu__item--active');

			// const contentItem = document.querySelector(`#${menuItem.dataset.content}`);

			if (contentItem) contentItem.classList.add('header-tabs-content__item--visible');
		});
	});

	const accordionLinkedImages = document.querySelectorAll('.accordion-linked-image');

	document.addEventListener('bricks/accordion/open', (event) => {
		const { elementId, openItem } = event.detail;

		// if (elementId !== 'fsjzhm') return;
		if (['fsjzhm', 'jeiech'].includes(elementId) === false) return;

		accordionLinkedImages.forEach((image) => {
			if (image.getAttribute('data-item') === openItem.id) {
				image.classList.add('visible');
			} else {
				image.classList.remove('visible');
			}
		});
	});

	const nestedSliders = document.querySelectorAll('.brxe-slider-nested');

	/**
	 * Refresh Nested Slider Splide instance after Bricks AJAX Query Results are displayed.
	 *
	 * @see https://academy.bricksbuilder.io/article/nestable-slider-instance/
	 * @see https://academy.bricksbuilder.io/article/custom-javascript-events-in-bricks/#bricks-ajax-query_result-displayed-code
	 */
	if (nestedSliders.length > 0) {
		document.addEventListener('bricks/ajax/query_result/displayed', (event) => {
			const queryId = event.detail.queryId;

			nestedSliders.forEach((nestedSlider) => {
				if (nestedSlider.contains(document.querySelector(`.brxe-${queryId}`))) {
					const nestedSliderInstanceID = nestedSlider.dataset.scriptId;

					if (nestedSliderInstanceID) {
						const instance = window.bricksData.splideInstances[nestedSliderInstanceID];

						if (instance) instance.refresh();
					}
				}
			});
		});
	}
});
